import React, { useMemo } from "react";

function ExamModuleView(props) {
  const uniqueClasses = useMemo(() => {
    if (!props.filteredTable?.length) return [];

    return props?.filteredTable?.reduce((acc, arr) => {
      const key = arr.yearLevelName;

      if (!acc[key]) {
        acc[key] = key;
      }

      return acc;
    }, {});
  });

  return (
    <>
      {props.printOption === "horizontal" &&
        (props?.classValue && props?.assessmentSubjectValue ? (
          <>
            {props?.routineData?.length > 0 &&
            props?.filtereduniqueDates?.length > 0 ? (
              <>
                {/* new table */}
                <div className="arr-table-container routine-table">
                  <table className="arr-table" border={1}>
                    <thead>
                      <tr>
                        {/* added minwidth style to evenly distribute width in table column /header */}
                        <th>
                          <div style={{ fontWeight: "600", fontSize: "13px" }}>
                            Class
                          </div>
                        </th>
                        {props?.filtereduniqueDates?.map((date) => {
                          const formattedDate = date?.split(" ")[0];
                          return (
                            <th key={date}>
                              <div
                                style={{ fontWeight: "600", fontSize: "13px" }}
                              >
                                {formattedDate}
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {props?.filteredTable &&
                        props?.filteredTable?.map((row) => {
                          const formattedValue = row?.yearLevelName?.replace(
                            /\s*\(Section\s+([^)]+)\)/,
                            " - $1",
                          );
                          return (
                            <tr key={row.yearLevelName}>
                              <td>
                                <div>
                                  <span
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "13px",
                                    }}
                                  >
                                    {formattedValue}
                                  </span>
                                  {/* <span style={{ fontSize: '12px' }}>{row?.yearLevelName?.slice(3, -1)}</span> */}
                                </div>
                              </td>
                              {props?.filtereduniqueDates?.map((date) => (
                                <td key={date}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "12px",
                                    }}
                                  >
                                    {row[date] && row[date].length > 0 ? (
                                      row[date].map((item, idx) => (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                          }}
                                          key={idx}
                                        >
                                          <span style={{ fontSize: "13px" }}>
                                            {item.subject}
                                          </span>
                                          {item.theoryTime && (
                                            <span style={{ fontSize: "13px" }}>
                                              {item.theoryTime}
                                            </span>
                                          )}
                                          {item.practicalTime && (
                                            <span style={{ fontSize: "13px" }}>
                                              {item.practicalTime}
                                            </span>
                                          )}
                                        </div>
                                      ))
                                    ) : (
                                      <div style={{ fontSize: "13px" }}>-</div>
                                    )}
                                  </div>
                                </td>
                              ))}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <>
                <p className="text-center mt-2">
                  The selected assessment is either not configured for the
                  specified class, or there are no students available in the
                  class.
                </p>
              </>
            )}
          </>
        ) : (
          <>
            <p className="text-center mt-2">
              Select the above field to view the records.
            </p>
          </>
        ))}

      {props.printOption === "vertical" &&
        (props?.classValue && props?.assessmentSubjectValue ? (
          <div
            style={{ boxShadow: "none" }}
            className="arr-table-container routine-table"
          >
            <table className="arr-table" border={1}>
              <thead>
                <tr>
                  <th style={{ fontWeight: "600", fontSize: "13px" }}>Dates</th>
                  {Object.values(uniqueClasses)?.map((item) => {
                    const [className, sectionPart] = item.split(" (");
                    const section = sectionPart.replace(")", "");
                    return (
                      <th
                        key={item}
                        style={{ fontWeight: "600", fontSize: "13px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{className}</span>
                          <span>{section}</span>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {props?.filtereduniqueDates?.map((date, index) => {
                  const fullDate = date?.split(" ");
                  const [, month, day] = fullDate[0].split("-");
                  const formattedDate = `${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                  return (
                    <tr key={date}>
                      <td style={{ fontWeight: "600", fontSize: "13px" }}>
                        {formattedDate}
                      </td>
                      {Object.values(uniqueClasses)?.map((yearLevel) => {
                        const row = props?.filteredTable?.find(
                          (item) => item.yearLevelName === yearLevel,
                        );

                        return (
                          <>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "12px",
                                }}
                              >
                                {row[date]?.length > 0 ? (
                                  row[date]?.map((row) => (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "4px",
                                      }}
                                    >
                                      {row?.subject ? (
                                        <>
                                          <span style={{ fontSize: "13px" }}>
                                            {row?.subject}
                                          </span>
                                          {row?.theoryTime && (
                                            <span style={{ fontSize: "13px" }}>
                                              {row?.theoryTime}
                                            </span>
                                          )}
                                          {row?.practicalTime && (
                                            <span style={{ fontSize: "13px" }}>
                                              {row?.practicalTime}
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        <div>-</div>
                                      )}
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  >
                                    -
                                  </div>
                                )}
                              </div>
                            </td>
                          </>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <>
            <p className="text-center mt-2">
              Select the above field to view the records.
            </p>
          </>
        ))}
    </>
  );
}

export default ExamModuleView;
